import React from 'react';
import { useSettings } from '@wix/tpa-settings/react';

import settingsParams from '../../settingsParams';

import { classes, st } from './Title.st.css';
import { FCWithChildren } from '@wix/challenges-web-library';

export interface ITitle {
  title?: string;
  subtitle?: string;
}

export const Title: FCWithChildren<ITitle> = (props) => {
  const settings = useSettings();

  return (
    <div className={st(classes.root, {})}>
      <h2 className={classes.title}>
        {props.title || (settings.get(settingsParams.pageTitleText) as string)}
      </h2>

      <p className={classes.subtitle}>
        {props.subtitle ||
          (settings.get(settingsParams.pageSubtitleText) as string)}
      </p>
    </div>
  );
};
